import { Button } from "@mui/material";

const CustomButton = ({
  name,
  fn,
  sx = {},
  hoverColor = "#F0473E",
  bgcolor = "#FE6F61",
}: {
  name: string;
  fn: (x: any) => any;
  sx?: Record<string, any>;
  hoverColor?: string;
  bgcolor?: string;
}) => {
  return (
    <Button
      variant='contained'
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor,
        color: "#fff",
        fontWeight: 700,
        borderRadius: 50,
        textTransform: "none",
        fontSize: { xs: 12, sm: 14, md: 16 },
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 1, sm: 1.5 },
        marginLeft: { xs: 0, sm: 0, md: 5 },

        transition: "transform 0.3s ease",

        // Sliding background
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: 0,
          height: "100%",
          bgcolor: hoverColor,
          borderRadius: "50px 0 0 50px", // rounded leading edge
          transition: "width 0.4s cubic-bezier(0.65, 0, 0.35, 1)",
          zIndex: 0,
        },

        "&:hover::before": {
          width: "100%",
          borderRadius: "50px", // fully rounded at end
        },

        // Text stays on top
        "& > span": {
          position: "relative",
          zIndex: 1,
          transition: "color 0.3s ease",
        },

        "&:hover": {
          transform: "scale(1.05)",
          color: "#fff", // text color changes on hover
        },
        ...sx,
      }}
      onClick={fn}
    >
      <span
        style={{
          position: "relative",
          zIndex: 1,
          transition: "color 0.3s ease",
        }}
      >
        {name}
      </span>
    </Button>
  );
};

export default CustomButton;
